import {Record} from 'immutable';

export const TeamCallActivity = Record({
  id: null,
  name: null,
  callsPlacedMax: null,
  callsPlacedAvg: null,
  totalCallDurationSecondsMax: null,
  totalCallDurationSecondsAvg: null,
  avgCallDurationSecondsMax: null,
  avgCallDurationSecondsAvg: null,
  talkListenRatioMax: null,
  talkListenRatioAvg: null,
  avgInterchangesPerMinuteMax: null,
  avgInterchangesPerMinuteAvg: null,
});

export class DonutStat extends Record({
  userId: null,
  score: null,
}) {
  constructor(object) {
    super({
      userId: object.userId,
      score: object.score,
    });
  }
}

const RepProfileCallActivity = Record({
  callsPlaced: null,
  totalCallDurationSeconds: null,
  avgCallDurationSeconds: null,
  talkListenRatio: null,
  avgInterchangesPerMinute: null,
});
export default RepProfileCallActivity;
